"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _date_formatter = require("../../../packages/common-utilities/src/date_formatter.js");

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _ramda = require("ramda");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _table_component = require("./global_components/table_component");

var _table_component2 = _interopRequireDefault(_table_component);

var _tabbed_generic_component = require("./global_components/tabbed_generic_component");

var _tabbed_generic_component2 = _interopRequireDefault(_tabbed_generic_component);

var _string_utility = require("../../../packages/common-utilities/src/string_utility.js");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _number_utility = require("../../../packages/common-utilities/src/number_utility.js");

var _number_utility2 = _interopRequireDefault(_number_utility);

var _button = require("./global_components/button");

var _button2 = _interopRequireDefault(_button);

var _functional_utility = require("../../../packages/common-utilities/src/functional_utility.js");

var _functional_utility2 = _interopRequireDefault(_functional_utility);

var _moment = require("moment/moment");

var _moment2 = _interopRequireDefault(_moment);

var _sanitize_utility = require("../../../packages/common-utilities/src/sanitize_utility");

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _collection_utility = require("common-utilities/src/collection_utility");

var _tracking_utility = require("common-utilities/src/tracking_utility");

var _functional_utility3 = require("../../../packages/common-utilities/src/functional_utility");

var _functional_utility4 = require("common-utilities/src/functional_utility");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FundDistributionCard = function (_React$Component) {
  _inherits(FundDistributionCard, _React$Component);

  function FundDistributionCard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FundDistributionCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FundDistributionCard.__proto__ || Object.getPrototypeOf(FundDistributionCard)).call.apply(_ref, [this].concat(args))), _this), _this.OneDecimalPercentage = ["reinvestNavPr", "distributionPeriodIncomeProportionPercentage", "distributionPeriodCapitalProportionPercentage", "distributionYearIncomeProportionPercentage", "distributionYearCapitalProportionPercentage"], _this.isCIFM = function () {
      return _this.props.legalStructureCode === "MAINLAND_FUND";
    }, _this.getDistributionErrorMessage = function () {
      var errorMsg = null;

      if (_collection_utility.CollectionUtility.includes(_this.props.visibleDataPoints, 'DISTRIBUTION_CARD_SHOW_ERROR_MESSAGE')) {
        if ((0, _ramda.isNil)(_this.props.distributionFrequency)) {
          errorMsg = _string_utility2.default.renderFormattedLabel("Distribution data will not be available.", "pdp-distribution-card-display-without-distribution-frequency-label");
        } else if (!_this.props.isShareclassMoreThanSixMonthsOld) {
          errorMsg = _string_utility2.default.renderFormattedLabel("Distribution data will be published for funds with a track record of over six months.", "pdp-distribution-card-display-less-than-six-month-label");
        }
      }
      return errorMsg;
    }, _this.renderDistributionErrorMessage = function (errorMsg) {
      return _react2.default.createElement(
        "div",
        { id: "distribution-error-message-card" },
        _react2.default.createElement(
          "div",
          { "data-testid": "distribution-error-message-div", className: "padding-left-0 padding-right-0" },
          _react2.default.createElement(
            "div",
            {
              className: "background-white border-radius-3 table-shadow padding-top-20 padding-bottom-5 padding-horizontal-30 " + (_this.props.breakpoint < 3 ? "margin-bottom-12" : "margin-bottom-30") },
            _react2.default.createElement(
              "div",
              { className: "card-header border-bottom-2 border-light-grey padding-bottom-15 print-hide",
                "data-testid": "distribution-tabs" },
              _react2.default.createElement(
                "h2",
                { "data-testid": "distribution-card-header-label",
                  className: "font-regular font-black-variant sub-header-3 print-hide" },
                _string_utility2.default.renderFormattedLabel("DISTRIBUTION HISTORY", "fund-distribution-tab-label")
              )
            ),
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "h3",
              { "data-testid": "distribution-card-error-message-label",
                id: "distribution-card-error-message-label",
                className: "font-regular font-black-variant sub-header-3 print-hide" },
              errorMsg
            ),
            _react2.default.createElement("br", null)
          )
        )
      );
    }, _this.renderDistributionCard = function () {
      var _this$props = _this.props,
          legalStructureCode = _this$props.legalStructureCode,
          shareClass = _this$props.shareClass,
          fundDistribution = _this$props.fundDistribution;

      var columnMappingForFundDistribution = _this.getColumnConfigForFundDistributionTab(shareClass);
      var columnMappingForCompositionFundDistribution = _this.getColumnConfigForCompositionTab(legalStructureCode);
      var displayTabbedData = _this.getTabbedData(fundDistribution, columnMappingForFundDistribution, columnMappingForCompositionFundDistribution);

      if ((0, _ramda.length)(_this.props.fundDistribution) < 1) {
        return null;
      }

      var shareClassName = _this.props.shareClass.name;
      var headerLabel = _this.doesDataPointContains('TW_DIVIDEND_HISTORY') ? _this.getHeaderLabelWithCurrencyAndDistributionFrequency("fundDistributionCard", _this.props.currencyCode, _this.props.distributionFrequencyLabel) : _this.getHeaderLabelWithIsinAndDate("2000-01-01", "fundDistributionCard", _this.props.shareClass.cusip);
      var headerTitle = _this.doesDataPointContains('TW_DIVIDEND_HISTORY') ? _string_utility2.default.renderFormattedLabel("DISTRIBUTION HISTORY", "fund-distribution-tab-label") : shareClassName;
      var shouldAlwaysShowMore = _this.doesDataPointContains('TW_DIVIDEND_HISTORY') ? true : null;
      return _react2.default.createElement(_tabbed_generic_component2.default, {
        activeCardHandler: function activeCardHandler() {
          return null;
        },
        breakpoint: _this.props.breakpoint,
        tabbedData: displayTabbedData,
        cardID: "fundDistributionCard",
        headerTitle: headerTitle,
        headerTitleLabel: "fund-distribution-header",
        headerLabel: headerLabel,
        displayTab: !_this.doesDataPointContains('TW_DIVIDEND_HISTORY'),
        dateRangeComponent: _this.props.dateRangeComponent,
        shouldAlwaysShowMore: shouldAlwaysShowMore
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FundDistributionCard, [{
    key: "generateTableHeaders",
    value: function generateTableHeaders(dataTestLabel, labelPrefix) {
      var _this2 = this;

      var fields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var markup = [];
      var columnIndex = 0;
      var headerLabel = "";
      _collection_utility.CollectionUtility.forEachIndexed(fields, function (value, key) {
        headerLabel = _string_utility2.default.getLocalizedString(_this2.props.intl, key, labelPrefix + "column-header-" + value);
        if (key === "FROM NET DISTRIBUTABLE INCOME FOR THE PERIOD") {
          headerLabel += "<sup>1)</sup>";
        }
        markup.push(_react2.default.createElement(
          "td",
          { className: "border-top-none tag " + (columnIndex > 0 ? "text-right" : ""),
            "data-testid": dataTestLabel + "-card-" + value
          },
          _this2.breakStringIntoNewLines(headerLabel)
        ));
        columnIndex++;
      });

      return markup;
    }
  }, {
    key: "breakStringIntoNewLines",
    value: function breakStringIntoNewLines(label) {
      if ((0, _ramda.isNil)(label)) {
        return null;
      }
      return _react2.default.createElement(
        "div",
        null,
        (0, _ramda.map)(function (current) {
          return _react2.default.createElement("span", { style: { 'display': 'block' },
            dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(current) } });
        }, label.split("\n"))
      );
    }
  }, {
    key: "generateTableRows",
    value: function generateTableRows(data, dataTestLabel) {
      var _this3 = this;

      var fields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var tableRows = [];
      var formattedValueOrDash = function formattedValueOrDash(value) {
        return value !== "-" ? value + "%" : value;
      };
      var decimalPlacePrecision = 4;

      if ((0, _functional_utility4.doesFormattingRulesContain)('DIVIDEND_TABLE_AMOUNT_AS_IS', this.props, ['formattingRules'])) {
        decimalPlacePrecision = -1;
      }

      var textRightOrEmptyString = function textRightOrEmptyString(columnIndex) {
        return columnIndex > 0 ? "text-right" : "";
      };

      var tableData = [];
      var columnIndex = 0;

      if ((0, _ramda.or)(!data, _collection_utility.CollectionUtility.size(data) < 1)) {
        return null;
      }

      _collection_utility.CollectionUtility.forEachIndexed(data, function (item, index) {
        var tableRow = _react2.default.createElement(
          "tr",
          { className: "category row-divider",
            "data-testid": dataTestLabel + "-data-" + index,
            id: dataTestLabel + "-data-" + index },
          tableData
        );
        columnIndex = 0;
        _collection_utility.CollectionUtility.forEachIndexed(fields, function (value) {

          if (value === 'distributionPeriodIncomeProportionPercentageYoungFund' || value === 'distributionPeriodCapitalProportionPercentageYoungFund') {
            value = value.replace('YoungFund', '');
          }

          var data = item[value];
          if (/date/gi.test(value)) {
            if (_collection_utility.CollectionUtility.includes((0, _functional_utility3.pathOrEmptyArray)(["formattingRules"], _this3.props), 'HISTORICAL_NAV_CHART_DATE_FORMAT_YYYY_MM_DD')) {
              data = _date_formatter2.default.getDateInYYYYMMDDSlashFormat(_functional_utility2.default.returnDashOrValue(data));
            } else {
              data = _date_formatter2.default.getDateInDDMMYYYSlashFormat(_functional_utility2.default.returnDashOrValue(data));
            }
          } else if (value === "dividendAmount") {
            data = _number_utility2.default.convertToAmountWithPreciseRounding(data, decimalPlacePrecision);
            var isBiMonthlyBonusIncluded = data !== '-' && !(0, _ramda.isNil)(_this3.props.historicalBiMonthlyBonusList) && _this3.props.historicalBiMonthlyBonusList[index].isBiMonthlyBonusIncluded;
            data += isBiMonthlyBonusIncluded ? ' ' + _string_utility2.default.getLocalizedString(_this3.props.intl, "Bi-Monthly Bonus", "bi-monthly-bonus") : '';
          } else if (value === "annualizedDividendYieldPercentage") {
            var _value = _number_utility2.default.convertToAmountWithPreciseRounding(data, 2);
            data = formattedValueOrDash(_value);
          } else if (value === 'navPrice' || value === 'cumulativeNoLoadPercentage' || value === "annualizedDividendYieldF2Percentage" || value === "currentDividendRationPercentage") {
            data = _number_utility2.default.convertToAmount(data, 2);
          } else if ((0, _ramda.and)(_this3.isCIFM(), (0, _ramda.or)(value === "distributionYearIncomeProportionPercentage", value === "distributionYearCapitalProportionPercentage"))) {
            var _value2 = _number_utility2.default.convertToAmountWithPreciseRounding(data, 0);
            data = formattedValueOrDash(_value2);
          } else if (_collection_utility.CollectionUtility.includes(_this3.OneDecimalPercentage, value)) {
            var _value3 = _number_utility2.default.convertToAmountWithPreciseRounding(data, 1);
            data = formattedValueOrDash(_value3);
          } else if ((0, _ramda.and)(_this3.props.legalStructureCode === "SICAV", (0, _ramda.or)(value === "distributionPeriodIncomeProportionPercentage", value === "distributionPeriodCapitalProportionPercentage"))) {
            var _value4 = _number_utility2.default.convertToAmountWithPreciseRounding(data, 0);
            data = formattedValueOrDash(_value4);
          } else if (value === 'currentRateOfReturn') {
            data = _number_utility2.default.convertToAmountWithPreciseRounding(data, 2, '-', false, true);
          }

          if ((0, _ramda.isNil)(data) || data === '-') {
            data = '-';
          } else if ((value === 'distributionPeriodIncomeProportionPercentage' || value === 'distributionPeriodCapitalProportionPercentage') && (0, _moment2.default)(item["exDate"]).isBefore((0, _moment2.default)("2019-06-01"))) {
            data += "<sup>2)</sup>";
            data = _react2.default.createElement("span", { style: { 'display': 'block' },
              dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(data) } });
          }

          tableData.push(_react2.default.createElement(
            "td",
            {
              className: "border-top-none " + textRightOrEmptyString(columnIndex) },
            data
          ));
          columnIndex++;
        });
        tableRows.push(tableRow);
        tableData = [];
      });

      return tableRows;
    }
  }, {
    key: "generateFundDistributionTable",
    value: function generateFundDistributionTable(data, fields, dataTestLabel, labelPrefix, tableHeaderLabel) {
      if ((0, _ramda.isNil)(data) || (0, _ramda.length)(data) < 1) {
        return null;
      }

      var excelType = "fundDistribution";

      var fromDate = (0, _ramda.last)(data).exDate;
      var toDate = data[0].exDate;

      var dataRange = this.doesDataPointContains('TW_DIVIDEND_HISTORY') ? '&fromDate=' + fromDate + '&toDate=' + toDate : '';

      var excelServiceURL = encodeURI(this.props.gaiaRedirectUrl + '/excel?type=' + excelType + '&cusip=' + this.props.cusip + '&country=' + this.props.country + '&role=' + this.props.role + '&locale=' + _string_utility2.default.generateLocale() + dataRange);

      if (dataTestLabel === "compositionOfFundDistributionCardTable") {
        if (this.isCIFM() && !(0, _ramda.isNil)(this.props.content) && this.props.content.documents[(0, _ramda.toUpper)(this.props.cusip)]) {
          this.props.content.documents[(0, _ramda.toUpper)(this.props.cusip)].forEach(function (document) {
            if (document.documentType === 'Income Distribution Rates') {
              excelServiceURL = document.docURL;
            }
          });
        } else {

          excelServiceURL = encodeURI(this.props.gaiaRedirectUrl + '/excel?type=compositionOfFundDistribution' + '&cusip=' + this.props.cusip + '&country=' + this.props.country + '&role=' + this.props.role + '&locale=' + _string_utility2.default.generateLocale());
        }
      }

      var headerFields = Object.assign({}, fields);

      if (this.isCIFM()) {
        headerFields['FROM CAPITAL SINCE LAST YEAR-END'] += "CIFM";
        headerFields['DISTRIBUTION PER UNIT/SHARE'] += "CIFM";
        headerFields['FROM NET DISTRIBUTABLE INCOME SINCE LAST YEAR-END'] += "CIFM";
      }

      return _react2.default.createElement(
        "div",
        { className: "margin-top-20" },
        _react2.default.createElement(_table_component2.default, {
          tableHeaders: this.generateTableHeaders(dataTestLabel, labelPrefix, headerFields),
          tableRows: this.generateTableRows(data, dataTestLabel, fields),
          tableBodyTest: "",
          activeTab: this.props.active,
          tableHeaderStyle: {},
          breakpoint: this.props.breakpoint
        }),
        _react2.default.createElement(_button2.default, {
          role: "adv",
          dataTest: labelPrefix + "download-data\"",
          downloadURL: excelServiceURL,
          dataTestLink: labelPrefix + "download-link",
          text: _string_utility2.default.renderFormattedLabel("Download data", "distribution-tab-download-data"),
          additionalClassName: "mobile-full-width",
          callBack: function callBack() {
            return _tracking_utility.TrackingUtility.trackEvent({
              "eventCategory": "pdp",
              "eventAction": tableHeaderLabel,
              "eventLabel": "download data"
            });
          }
        })
      );
    }
  }, {
    key: "render",
    value: function render() {
      var errMsg = this.getDistributionErrorMessage();
      return (0, _ramda.isNil)(errMsg) ? this.renderDistributionCard() : this.renderDistributionErrorMessage(errMsg);
    }
  }, {
    key: "getColumnConfigForCompositionTab",
    value: function getColumnConfigForCompositionTab(legalStructureCode) {
      var columnMappingForCompositionFundDistribution = void 0;
      if (legalStructureCode === "MAINLAND_FUND") {
        columnMappingForCompositionFundDistribution = {
          "RECORD DATE": "recordDate",
          "EX-DIVIDEND DATE": "exDate",
          "DISTRIBUTION PER UNIT/SHARE": "dividendAmount",
          "FROM NET DISTRIBUTABLE INCOME SINCE LAST YEAR-END": "distributionYearIncomeProportionPercentage",
          "FROM CAPITAL SINCE LAST YEAR-END": "distributionYearCapitalProportionPercentage"
        };
      } else {
        columnMappingForCompositionFundDistribution = {
          "EX-DIVIDEND DATE": "exDate",
          "DISTRIBUTION PER UNIT/SHARE": "dividendAmount",
          "FROM NET DISTRIBUTABLE INCOME FOR THE PERIOD": "distributionPeriodIncomeProportionPercentage" + (this.props.isShareclassMoreThanSixMonthsOld ? "" : "YoungFund"),
          "FROM CAPITAL FOR THE PERIOD": "distributionPeriodCapitalProportionPercentage" + (this.props.isShareclassMoreThanSixMonthsOld ? "" : "YoungFund")
        };
      }

      return columnMappingForCompositionFundDistribution;
    }
  }, {
    key: "getColumnConfigForFundDistributionTab",
    value: function getColumnConfigForFundDistributionTab(shareClass) {
      var columnMappingForFundDistribution = void 0;
      if (this.doesDataPointContains('TW_DIVIDEND_HISTORY')) {
        columnMappingForFundDistribution = {
          "DISTRIBUTION PER UNIT (CLASS CURRENCY)": "dividendAmount",
          "EX-DIVIDEND DATE": "exDate",
          "PAYMENT/ REINVESTMENT DATE": "payDate",
          "Current dividend ratio": "currentDividendRationPercentage",
          "Current rate of return": "currentRateOfReturn"
        };
      } else if (shareClass.distributingCode === 'DIST') {
        columnMappingForFundDistribution = {
          "RECORD DATE": "recordDate",
          "EX-DIVIDEND DATE": "exDate",
          "PAYMENT/ REINVESTMENT DATE": "payDate",
          "DISTRIBUTION PER UNIT/SHARE": "dividendAmount"
        };
      } else {
        columnMappingForFundDistribution = {
          "RECORD DATE": "recordDate",
          "EX-DIVIDEND DATE": "exDate",
          "DISTRIBUTION PER UNIT (CLASS CURRENCY)": "dividendAmount",
          "EX-DIVIDEND PRICE (CLASS CURRENCY)": "navPrice",
          "ANNUALISED YIELD": "annualizedDividendYieldPercentage",
          "PAYMENT/ REINVESTMENT DATE": "payDate"
        };
      }
      return columnMappingForFundDistribution;
    }
  }, {
    key: "getTabbedData",
    value: function getTabbedData(fundDistribution, columnMappingForFundDistribution, columnMappingForCompositionFundDistribution) {
      var displayTabbedData = void 0;
      var cardFundDistribution = (0, _ramda.pathOr)([], ['disclosures', 'pdpCardFundDistribution'], this.props);
      var pdpCardFundDistributionFrequency = (0, _ramda.pathOr)([], ['disclosures', 'pdpCardFundDistributionFrequency'], this.props);
      var distributionDisclosureText = cardFundDistribution.concat(pdpCardFundDistributionFrequency);
      var compositionFundDistributionText = (0, _ramda.pathOr)(null, ["disclosures", "pdpCardCompositionFundDistribution"], this.props);
      var compositionOfFundDistributionTabbedData = {
        id: "compositionOfFundDistributionCardTable",
        label: _string_utility2.default.renderFormattedLabel("Composition of Fund Distribution", "composition-of-fund-distribution-tab-label"),
        tabContent: this.generateFundDistributionTable(this.filterCompositionFundDistributionData(fundDistribution), columnMappingForCompositionFundDistribution, "compositionOfFundDistributionCardTable", "fund-distribution-composition-", 'composition of fund distribution'),
        disclosureText: compositionFundDistributionText,
        eventAction: 'distribution card',
        eventLabel: 'composition of fund distribution',
        placementId: "pdpCardCompositionFundDistribution"
      };
      var fundDistributionTabbedData = {
        id: "fundDistributionCardTable",
        label: _string_utility2.default.renderFormattedLabel("Fund Distribution", "fund-distribution-tab-label"),
        tabContent: this.generateFundDistributionTable(fundDistribution, columnMappingForFundDistribution, "fundDistributionCardTable", "fund-distribution-", 'fund distribution'),
        disclosureText: distributionDisclosureText,
        eventAction: 'distribution card',
        eventLabel: 'fund distribution',
        placementId: "pdpCardFundDistribution-" + "pdpCardFundDistributionFrequency"
      };

      if (this.isCIFM()) {
        displayTabbedData = [compositionOfFundDistributionTabbedData];
      } else if (this.doesDataPointContains('TW_DIVIDEND_HISTORY')) {
        displayTabbedData = [fundDistributionTabbedData];
      } else {
        displayTabbedData = [fundDistributionTabbedData, compositionOfFundDistributionTabbedData];
      }

      return displayTabbedData;
    }
  }, {
    key: "filterCompositionFundDistributionData",
    value: function filterCompositionFundDistributionData(fundDistribution) {
      if (this.props.shareClass.distributingCode === 'DIST') {
        return _collection_utility.CollectionUtility.filter(fundDistribution, function (distribution) {
          return distribution.calculatedPeriod === '1YEAR';
        });
      }
      return fundDistribution;
    }
  }, {
    key: "getHeaderLabelWithIsinAndDate",
    value: function getHeaderLabelWithIsinAndDate(effectiveDate, cardID, isin) {
      var formattedDate = _date_formatter2.default.getTranslatedHeaderWithDate(_date_formatter2.default.getMonthEndDateBeforeNMonths(new Date(), 1), 'pdp-as-of-date-header');
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "span",
            { "data-testid": cardID + "Isin", className: "font-light disclaimer" + _functional_utility2.default.ifMobileBreakpoint(this.props.breakpoint, " padding-left-16", "") },
            "ISIN: ",
            isin
          )
        ),
        _react2.default.createElement(
          "span",
          {
            id: cardID + "-effective-date", className: "font-light disclaimer" + _functional_utility2.default.ifMobileBreakpoint(this.props.breakpoint, " padding-left-16", ""),
            "data-testid": cardID + "-as-of-date-header" },
          formattedDate
        )
      );
    }
  }, {
    key: "getHeaderLabelWithCurrencyAndDistributionFrequency",
    value: function getHeaderLabelWithCurrencyAndDistributionFrequency(cardID, currency, distributionFrequency) {
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "span",
            { "data-testid": cardID + "-currency", className: "font-light disclaimer" + _functional_utility2.default.ifMobileBreakpoint(this.props.breakpoint, " padding-left-16", "") },
            _string_utility2.default.renderFormattedLabel("DISTRIBUTION CURRENCY", "fund-distribution-currency-label"),
            ":\xA0",
            _string_utility2.default.renderFormattedLabel("", "currency-code-" + currency)
          )
        ),
        _react2.default.createElement(
          "span",
          {
            id: cardID + "-distribution-frequency", className: "font-light disclaimer" + _functional_utility2.default.ifMobileBreakpoint(this.props.breakpoint, " padding-left-16", ""),
            "data-testid": cardID + "-distribution-frequency" },
          _string_utility2.default.renderFormattedLabel("DISTRIBUTION FREQUENCY", "fund-distribution-frequency-label"),
          ":\xA0",
          _string_utility2.default.renderFormattedLabel("", distributionFrequency)
        )
      );
    }
  }, {
    key: "doesDataPointContains",
    value: function doesDataPointContains(visibleDataPointName) {
      return (0, _functional_utility3.doesVisibleDataPointContains)(visibleDataPointName, this.props, ["visibleDataPoints"]);
    }
  }]);

  return FundDistributionCard;
}(_react2.default.Component);

exports.default = FundDistributionCard;